import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { QueryKeys } from '../../key-registry'
import { markLastReadNow } from '../models/newsLastRead'

// Visiting the feed is what marks it read — but only once it has actually loaded. Marking a feed
// read that never arrived would bury every post the reader never saw.
function useMarkNewsRead(userId: number | undefined, hasLoaded: boolean) {
  const queryClient = useQueryClient()

  useEffect(() => {
    if (userId === undefined || !hasLoaded) {
      return
    }

    markLastReadNow(userId)
    queryClient.invalidateQueries({ queryKey: QueryKeys.news.unreadCountAll() })
  }, [userId, hasLoaded, queryClient])
}

export default useMarkNewsRead
